import PazienteAnalisiRischiTh from "../";

const routes = [
    { name: "AnalisiRischiThList", path: "/paziente/analisirischith", component: PazienteAnalisiRischiTh.AnalisiRischiThList, meta: { title: "riskAnalysis.lblTitle" } },
    { name: "AnalisiRischiThView", path: "/paziente/analisirischith/view/:id", component: PazienteAnalisiRischiTh.AnalisiRischiThView, meta: { title: "riskAnalysis.lblTitle" } },
    { name: "AnalisiRischiThEdit", path: "/paziente/analisirischith/edit/:id", component: PazienteAnalisiRischiTh.AnalisiRischiThEdit, meta: { title: "riskAnalysis.lblTitle" } },
];

export default routes;
